<template>
  <v-container fluid class="mt-n2">
    <v-row>
      <v-col cols="12" :lg="showImageViewer ? 7 : 12" :xl="showImageViewer ? 7 : 12">
        <v-row>
          <v-col cols="12" lg="6" xl="6">
            <DetailCard :title="$t('load')">
              <v-row>
                <v-col cols="12" xl=""
            :propStyle="styleForTabs ? { borderRadius: '0px 4px 4px 4px' } : null">
                  <v-row no-gutters>
                    <v-col :cols="infoColumnBreakpoint">
                      {{$t('createdAt')}}:
                    </v-col>
                    <v-col>
                      {{utcToLocalDate(ticket.loadCreatedAt, 'L - LT')}}
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-if="ticket.departedAt">
                    <v-col :cols="infoColumnBreakpoint">
                      {{$t('departedAt')}}:
                    </v-col>
                    <v-col>
                      {{utcToLocalDate(ticket.departedAt, 'L - LT')}}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col :cols="infoColumnBreakpoint">
                      {{$t('weighedInAt')}}:
                    </v-col>
                    <v-col>
                      {{utcToLocalDate(ticket.weighedInAt, 'L - LT')}}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col :cols="infoColumnBreakpoint">
                      {{$t('inTransit')}}
                    </v-col>
                    <v-col>
                      {{timeBetween(ticket.loadCreatedAt, ticket.weighedInAt)}}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col :cols="infoColumnBreakpoint">
                      {{$t('weighedOut')}}:
                    </v-col>
                    <v-col>
                      {{utcToLocalDate(ticket.weighedOutAt, 'L - LT')}}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col :cols="infoColumnBreakpoint">
                      {{$t('inYard')}}:
                    </v-col>
                    <v-col>
                      {{timeBetween(ticket.weighedInAt, ticket.weighedOutAt)}}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col :cols="infoColumnBreakpoint">
                      {{ $t('product') }}:
                    </v-col>
                    <v-col>
                      {{ticket.product || $t('notAvailable')}}
                    </v-col>
                  </v-row>
                  <v-row v-if="ticket.hasLogCounts && isLogsTicket" no-gutters>
                    <v-col :cols="infoColumnBreakpoint">
                      <span id="log-count-info">{{ $t('pieceCount') }}:</span>
                    </v-col>
                    <v-col>
                      <span id="log-count-shortcut" @click="$emit('logCounts')">{{ticket.pieces || $t('notAvailable')}}</span>
                    </v-col>
                  </v-row>
                  <v-row v-if="!ticket.hasLogCounts && isLogsTicket" no-gutters>
                    <v-col :cols="infoColumnBreakpoint">
                      {{ $t('pieceCount') }}:
                    </v-col>
                    <v-col>
                      {{ticket.pieces || $t('notAvailable')}}
                    </v-col>
                  </v-row>
                  <v-row v-if="isLogsTicket" no-gutters>
                    <v-col :cols="infoColumnBreakpoint">
                      {{ $t('averageSED') }}:
                    </v-col>
                    <v-col>
                      {{ticket.averageSED || $t('notAvailable')}}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" md="auto" lg="12" xl="auto" :style="{ maxWidth: '50%' }" v-if="useWideLayout">
                  <ContractKeyCard :contract="contractForKeyCard"/>
                </v-col>
              </v-row>
            </DetailCard>
          </v-col>

          <v-col cols="12" lg="6" :xl="useWideLayout ? '' : 6">
            <DetailCard :title="$t('misc') ">
              <v-row no-gutters>
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('trailerId')}}:
                </v-col>
                <v-col>
                  {{ticket.trailerIdentifier}}
                </v-col>
              </v-row>
              <v-row no-gutters v-if="ticket.seal">
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('seal')}}:
                </v-col>
                <v-col>
                  {{ticket.seal}}
                </v-col>
              </v-row>
              <v-row no-gutters v-if="ticket.logger && isLogsTicket">
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('logger')}}:
                </v-col>
                <v-col>
                  <AccountName
                    :accountId="ticket.loggerAccountId"
                    :certificationStatus="ticket.loggerCertificationStatus"
                  >
                    {{ticket.logger || $t('notAvailable')}}
                  </AccountName>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('driver')}}:
                </v-col>
                <v-col>
                  {{ ticket.correctedDriver ?? ticket.driver ?? $t('notSpecified') }}
                </v-col>
              </v-row>

              <v-row no-gutters v-if="ticket.deckId !== null">
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('destinationDeck')}}:
                </v-col>
                <v-col>
                  {{ticket.deckName || $t('notAvailable')}}
                </v-col>
              </v-row>

              <v-row no-gutters v-if="ticket.fromDeckId !== null">
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('fromDeck')}}:
                </v-col>
                <v-col>
                  {{ticket.fromDeckName || $t('notAvailable')}}
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('createdOn')}}:
                </v-col>
                <v-col>
                  <v-row no-gutters>
                    <v-col cols="auto">
                      <Icon :icon="TicketOrigin.forInt(ticket.origin).icon" iconColor="black"/>
                    </v-col>
                    <v-col>
                      <span>{{ getDeviceString() }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row v-if="isLogsTicket" no-gutters>
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('averageLength')}}:
                </v-col>
                <v-col>
                  {{ticket.averageLength || $t('notAvailable')}}
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('extTicketNumber1')}}:
                </v-col>
                <v-col>
                  {{ticket.extTicketNumber1 || extTicketNumberTextField}}
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('extTicketNumber2')}}:
                </v-col>
                <v-col cols="auto" v-if="ticket.ticketBookPageId !== null">
                  <Icon icon="mdi-book-open-variant" iconColor="black" :tooltipText="$t('ticketBook')"/>
                </v-col>
                <v-col :cols="infoColumnBreakpoint">
                  {{ticket.extTicketNumber2 || extTicketNumberTextField}}
                </v-col>
              </v-row>

              <v-row no-gutters v-if="ticket.rolledOutAt !== null">
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('rolloutActive')}}:
                </v-col>
                <v-col>
                  {{utcToLocalDate(ticket.rolledOutAt, 'L - LT')}}
                </v-col>
              </v-row>

              <v-row no-gutters v-if="ticket.rolloutCompletedAt !== null">
                <v-col :cols="infoColumnBreakpoint">
                  {{ $t('rolloutCompleted') }}:
                </v-col>
                <v-col>
                  {{utcToLocalDate(ticket.rolloutCompletedAt, 'L - LT')}}
                </v-col>
              </v-row>

              <v-row no-gutters v-if="ticket.yardInstructionId && yardInstruction?.status === YardInstructionStatus.Active.value">
                <v-col :cols="infoColumnBreakpoint">
                  {{$t('yardInstruction')}}:
                </v-col>
                <v-col>
                  {{yardInstruction.name}}
                </v-col>
              </v-row>
            </DetailCard>
          </v-col>

          <v-col cols="12" md="6" v-if="!useWideLayout">
            <ContractKeyCard :contract="contractForKeyCard" />
          </v-col>

          <v-col cols="12" md="6" :xl="useWideLayout ? 'auto' : 6" style="min-width: 256px">
            <DetailCard :title="$t('weight') ">
              <template #title.append>
                <v-btn small :class="weightButtonClass" @click="toggleWeightUnit" style="min-width: 80px;">
                  <v-icon small class="mr-1" color="white">mdi-scale</v-icon>
                  <span>{{ weightButtonText }}</span>
                </v-btn>
              </template>
              <v-row no-gutters>
                <v-col :cols="infoColumnBreakpoint" class="pr-2">
                  {{$t('in')}}:
                </v-col>
                <v-col class="text-right weightfield" :cols="weightCols">
                  {{displayWeight(ticket.inWeight)}}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col :cols="infoColumnBreakpoint" class="pr-2">
                  {{$t('out')}}:
                </v-col>
                <v-col class="text-right weightfield" :cols="weightCols">
                  {{displayWeight(ticket.outWeight)}}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col :cols="infoColumnBreakpoint" class="pr-2">
                  {{defectWeightBreakdown !== undefined ? $t('totalDefect') : $t('defect')}}:
                </v-col>
                <v-col class="text-right weightfield" :cols="weightCols">
                  {{displayWeight(ticket.defectWeight)}}
                </v-col>
              </v-row>
              <v-row no-gutters v-if="defectWeightBreakdown !== undefined">
                <v-col :cols="infoColumnBreakpoint" class="pr-2">
                  {{$t('natureDefect')}}:
                </v-col>
                <v-col class="text-right weightfield" :cols="weightCols">
                  {{displayWeight(defectWeightBreakdown.natureDefectWeight)}}
                </v-col>
              </v-row>
              <v-row no-gutters v-if="defectWeightBreakdown !== undefined">
                <v-col :cols="infoColumnBreakpoint" class="pr-2">
                  {{$t('mismanufacturedDefect')}}:
                </v-col>
                <v-col class="text-right weightfield" :cols="weightCols">
                  {{displayWeight(defectWeightBreakdown.mismanufactureDefectWeight)}}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col :cols="infoColumnBreakpoint" class="pr-2">
                  {{$t('net')}}:
                </v-col>
                <v-col class="text-right weightfield" :cols="weightCols">
                  {{getNetWeight()}}
                </v-col>
              </v-row>
              <v-row v-if="hasDepartureWeight" no-gutters>
                <v-col :cols="infoColumnBreakpoint" class="pr-2">
                  {{$t('departure')}}:
                </v-col>
                <v-col class="text-right weightfield" :cols="weightCols">
                  {{displayWeight(ticket.departureWeight)}}
                </v-col>
              </v-row>
            </DetailCard>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" lg="5">
        <v-card>
          <TicketImageViewer
            v-if="showImageViewer"
            :ticketNumber="ticket.ticketNumber"
            :ticketImageData="ticketImageData"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { utcToLocalDate, timeBetween } from '@/utils/DateFormatter.js'
import { tonStringFromPounds, numberWithCommas } from '@/utils/NumericMutations.js'
import { ticketRecognitionClient } from '@/utils/TicketImages.js'
import { DefectCategory, CorrectionType, ContractType, TicketOrigin, YardInstructionStatus } from '@/utils/Enumerations.js'
import { mapGetters } from 'vuex'
import { colorClassForContractType, contractTypeHasDepartureWeight } from '@/utils/componentHelpers.js'
import IconHelpers from '@/utils/IconHelpers'

export default {
  name: 'TicketInformation',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    AccountName: () => import('@/components/account/AccountName.vue'),
    TicketImageViewer: () => import('@/components/ticket/TicketImageViewer.vue'),
    DetailCard: () => import('@/components/core/DetailCard.vue'),
    ContractKeyCard: () => import('@/components/contract/ContractKeyCard.vue')
  },

  props: {
    ticket: {
      type: Object,
      required: true
    },
    corrections: {
      type: Array,
      default: () => []
    },
    shouldFetchImages: {
      type: Boolean,
      default: true
    },
    styleForTabs: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    IconHelpers,
    TicketOrigin,
    YardInstructionStatus,
    logCounts: false,
    ticketImageData: [],
    yardInstruction: null,
    displayInPounds: false
  }),

  computed: {
    ...mapGetters('defects', ['allTicketDefects']),
    ...mapGetters('locations', ['allLocationsByAccountId']),

    defectWeightBreakdown () {
      if (this.allTicketDefects.length === 0) return

      if (this.corrections.length > 0) {
        const correction = this.corrections[0].correction
        if (correction.type === CorrectionType.SpecifyNewTicketValues.value) {
          return {
            natureDefectWeight: correction.natureDefectWeight,
            mismanufactureDefectWeight: correction.mismanufactureDefectWeight
          }
        }
      }

      return this.allTicketDefects.reduce((total, defect) => {
        switch (defect.category) {
          case DefectCategory.Nature.value:
            total.natureDefectWeight += defect.totalLBS
            break
          case DefectCategory.Mismanufactured.value:
            total.mismanufactureDefectWeight += defect.totalLBS
            break
        }
        return total
      }, { natureDefectWeight: 0, mismanufactureDefectWeight: 0 })
    },

    infoColumnBreakpoint () {
      return ''
    },

    weightCols () {
      return 'auto'
    },

    showImageViewer () {
      return this.ticketImageData.length > 0
    },

    isLogsTicket () {
      return this.ticket.contractType === ContractType.Production.value ||
      this.ticket.contractType === ContractType.WoodsSale.value ||
      this.ticket.contractType === ContractType.LogYardSale.value
    },

    extTicketNumberTextField () {
      return this.isLogsTicket ? this.$t('notAvailable') : ''
    },

    hasDepartureWeight () {
      return contractTypeHasDepartureWeight(this.ticket.contractType)
    },

    contractForKeyCard () {
      const { fromAccount, account, accountCertificationStatus, tract, tractIsCertified, setting, destination } = this.ticket
      return {
        fromAccount,
        account,
        accountCertificationStatus,
        tract,
        tractIsCertified,
        setting,
        destination
      }
    },

    useWideLayout () {
      return this.$vuetify.breakpoint.xl && !this.showImageViewer
    },

    weightButtonClass () {
      return colorClassForContractType(this.ticket.contractType)
    },

    weightButtonText () {
      return this.displayInPounds ? this.$t('lbsUpper') : this.$t('tonsUpper')
    }
  },

  async created () {
    if (this.shouldFetchImages) {
      this.ticketImageData = await ticketRecognitionClient.getRecognitionData(this.ticket.ticketId, false)
    }

    if (this.ticket.yardInstructionId) {
      this.yardInstruction = this.allLocationsByAccountId[this.ticket.destinationAccountId]?.yardInstructions.find(
        instruction => instruction.yardInstructionId === this.ticket.yardInstructionId
      )
    }
  },

  methods: {
    utcToLocalDate,
    tonStringFromPounds,
    timeBetween,
    getNetWeight () {
      return this.displayWeight(this.ticket.inWeight - this.ticket.outWeight - this.ticket.defectWeight)
    },

    getDeviceString () {
      switch (this.ticket.origin) {
        case TicketOrigin.WebClient.value:
          return this.$t('office')
        case TicketOrigin.Loader.value:
          return this.$t('createdOnLoader')
        case TicketOrigin.Receiver.value:
          return this.$t('createdOnReceiver')
        case TicketOrigin.YardOperator.value:
          return this.$t('createdOnYardOperator')
        case TicketOrigin.Transporter.value:
          return this.$t('createdOnTransporter')
        case TicketOrigin.Kiosk.value:
          return this.$t('createdOnKiosk')
      }
    },

    toggleWeightUnit () {
      this.displayInPounds = !this.displayInPounds
    },

    displayWeight (pounds) {
      if (this.displayInPounds) {
        return numberWithCommas(pounds)
      }
      return this.tonStringFromPounds(pounds)
    }
  }
}
</script>

<style>
  #log-count-info {
    color: #D15F27;
  }
  #log-count-shortcut {
    cursor: pointer;
    background-color: #D15F27;
    color: white;
    border: #D15F27 solid 1px;
    font-weight: 900;
    transition: all 0.4s ease;
    padding: 1px 6px;
    border-radius: 50%;
  }
  #log-count-shortcut:hover {
    color: #f75504;
    background-color: transparent;
  }
  .weightfield {
    font-family: 'IBM Plex Mono', monospace;
  }
</style>
